module.exports = __webpack_public_path__ + "static/img/24fcdc79a7103ea82ffbc3baeff9ce41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advant_active_02.png
// module id = C+mM
// module chunks = 1